<template>
  <div class="estado_box_responsive">
    <h3>{{ $t("procedimento.UMA_LANG_DOCSBOLSA_ESTADO_ACTUAL") }}</h3>
    <h4>{{ estado }}</h4>
  </div>
</template>

<script>
export default {
  props: ["estado"],
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.estado_box_responsive {
  display: none;
}

@media (max-width: 1024px) {
  .estado_box_responsive {
    display: block;
    background-color: #6eb7ec;
    padding-bottom: 8px;
    margin-bottom: 0px;
  }

  .estado_box_responsive h3 {
    font-size: 15px;
    font-family: "Montserrat Bold";
    text-transform: uppercase;
    color: white;
    margin-bottom: 0px;
    padding: 25px;
    padding-right: 0px;
    padding-bottom: 10px;
    padding-top: 13px;
    display: inline-block;
    margin-right: 5px;
  }

  .estado_box_responsive h4 {
    font-family: "Montserrat Bold";
    font-size: 15px;
    display: inline-block;
    color: white;
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media screen and (max-width: 767px) {
  .estado_box_responsive {
    padding-bottom: 5px;
    padding-top: 5px;
    margin-bottom: 0px;
  }

  .estado_box_responsive h3 {
    display: inline-block;
    margin-bottom: 0px;
    padding: 0px;
    padding-left: 20px;
    padding-top: 5px;
    font-size: 14px;
  }

  .estado_box_responsive h4 {
    display: inline-block;
    font-size: 14px;
  }
}
</style>
